import { render, staticRenderFns } from "./AdminCourses.vue?vue&type=template&id=3977abd1&scoped=true"
import script from "./AdminCourses.vue?vue&type=script&lang=js"
export * from "./AdminCourses.vue?vue&type=script&lang=js"
import style0 from "./AdminCourses.vue?vue&type=style&index=0&id=3977abd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3977abd1",
  null
  
)

export default component.exports